import React from "react";
import { TooltipProps } from "recharts";
import {
  NameType,
  ValueType,
} from "recharts/types/component/DefaultTooltipContent";

import { IgTypography } from "@intelligems/ig-theme";
import { GraphConfig } from "@intelligems/ig-types";
import { Box, useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useGraphValueFormatter } from "@src/features/analytics/hooks/use-graph-value-formatter";
import { AnalyticsLegendIcon } from "@src/images/Icons/AnalyticsLegendIcon";

const fontSize = "14px";
const lineHeight = "16px";
const letterSpacing = ".4px";

export const IgHistogramTooltip = ({
  active,
  payload,
  label,
  config,
}: TooltipProps<ValueType, NameType> & { config: GraphConfig }) => {
  const theme = useTheme();
  const graphValueFormatter = useGraphValueFormatter();

  if (!active || !payload) return null;

  return (
    <Box
      sx={{
        padding: "10px",
        minWidth: "100px",
        borderRadius: "5px",
        backgroundColor: "rgba(73, 76, 80, 0.92)",
      }}
    >
      <Grid container direction={"column"}>
        <Grid>
          <IgTypography
            sx={{
              color: theme.igPrimitives.gray[500],
              fontSize,
              fontWeight: 700,
              letterSpacing,
              lineHeight,
            }}
          >
            {graphValueFormatter({
              isAxisTick: false,
              value: label,
              configDataTypes: config.dataTypes,
            })}{" "}
            {!config.dataTypes.includes("currencyNoDecimal") ? "Unit" : ""}
            {!config.dataTypes.includes("currencyNoDecimal") && label > 1
              ? "s"
              : ""}
          </IgTypography>
        </Grid>
        {payload.map((pay, index) => (
          <Grid
            key={`${pay.name}-${index}`}
            container
            direction={"row"}
            justifyContent={"space-between"}
          >
            <Grid>
              <AnalyticsLegendIcon
                sx={{
                  width: "10px",
                  height: "10px",
                  paddingLeft: "8px",
                  paddingRight: "13px",
                }}
                fill={pay.color}
              />
              <IgTypography
                sx={{
                  color: theme.igPrimitives.gray[500],
                  fontSize,

                  letterSpacing,
                  lineHeight,
                }}
              >
                {pay.value} Orders
              </IgTypography>
            </Grid>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
